import { Box, Button, Container, Radio, Stack } from "@mui/material";
import { useEffect, useRef } from "react";
import { TestType } from "../types/guestTestTemplate";
import axios from "axios";
import { useRecoilValue } from "recoil";
import userState from "../../recoil/atoms/userState";


const GTTest = ({
    data, setMode, tryingNo, setTryingNo, answers, setAnswers, scores, setScores,
}:{
    data: TestType[],
    setMode: (to:('desc' | 'test' | 'result')) => void,
    tryingNo: number,
    setTryingNo: (tryingNo: number) => void,
    answers: (number|null)[],
    setAnswers: (answers: (number|null)[]) => void,
    scores: (number)[],
    setScores: (answers: (number)[]) => void,
}) => {

    const userData = useRecoilValue(userState); // Recoilのユーザー情報を取得

    // 回答選択
    const selectChoice = (no: number, choice: number) => {
        const tmpAnswers: (number|null)[] = [];
        for(let i = 0; i < 35; i++) {
            tmpAnswers.push(i === no ? choice : answers[i]);
        }
        setAnswers(tmpAnswers);
    }

    /**
     * 中断データ取得
     */
    const initFlag = useRef(false); // 再レンダリング防止用フラグ
    const getSavedData = () => {
        axios.post(process.env.REACT_APP_BE_HOST + 'tmpData/InterruptedDataRetrieval', {
            "userId": userData.userId,
        }, {
            withCredentials: true
        }).then((res: any) => {
            if (res.data) {
                if (window.confirm("中断データから再開しますか？")) {
                    setAnswers([
                        res.data.choiceNum1 ? Number(res.data.choiceNum1) : null,
                        res.data.choiceNum2 ? Number(res.data.choiceNum2) : null,
                        res.data.choiceNum3 ? Number(res.data.choiceNum3) : null,
                        res.data.choiceNum4 ? Number(res.data.choiceNum4) : null,
                        res.data.choiceNum5 ? Number(res.data.choiceNum5) : null,
                        res.data.choiceNum6 ? Number(res.data.choiceNum6) : null,
                        res.data.choiceNum7 ? Number(res.data.choiceNum7) : null,
                        res.data.choiceNum8 ? Number(res.data.choiceNum8) : null,
                        res.data.choiceNum9 ? Number(res.data.choiceNum9) : null,
                        res.data.choiceNum10 ? Number(res.data.choiceNum10) : null,
                        res.data.choiceNum11 ? Number(res.data.choiceNum11) : null,
                        res.data.choiceNum12 ? Number(res.data.choiceNum12) : null,
                        res.data.choiceNum13 ? Number(res.data.choiceNum13) : null,
                        res.data.choiceNum14 ? Number(res.data.choiceNum14) : null,
                        res.data.choiceNum15 ? Number(res.data.choiceNum15) : null,
                        res.data.choiceNum16 ? Number(res.data.choiceNum16) : null,
                        res.data.choiceNum17 ? Number(res.data.choiceNum17) : null,
                        res.data.choiceNum18 ? Number(res.data.choiceNum18) : null,
                        res.data.choiceNum19 ? Number(res.data.choiceNum19) : null,
                        res.data.choiceNum20 ? Number(res.data.choiceNum20) : null,
                        res.data.choiceNum21 ? Number(res.data.choiceNum21) : null,
                        res.data.choiceNum22 ? Number(res.data.choiceNum22) : null,
                        res.data.choiceNum23 ? Number(res.data.choiceNum23) : null,
                        res.data.choiceNum24 ? Number(res.data.choiceNum24) : null,
                        res.data.choiceNum25 ? Number(res.data.choiceNum25) : null,
                        res.data.choiceNum26 ? Number(res.data.choiceNum26) : null,
                        res.data.choiceNum27 ? Number(res.data.choiceNum27) : null,
                        res.data.choiceNum28 ? Number(res.data.choiceNum28) : null,
                        res.data.choiceNum29 ? Number(res.data.choiceNum29) : null,
                        res.data.choiceNum30 ? Number(res.data.choiceNum30) : null,
                        res.data.choiceNum31 ? Number(res.data.choiceNum31) : null,
                        res.data.choiceNum32 ? Number(res.data.choiceNum32) : null,
                        res.data.choiceNum33 ? Number(res.data.choiceNum33) : null,
                        res.data.choiceNum34 ? Number(res.data.choiceNum34) : null,
                        res.data.choiceNum35 ? Number(res.data.choiceNum35) : null,
                    ]);
                    setTryingNo(res.data.questionNum)
                }
                // 中断データ削除
                axios.post(process.env.REACT_APP_BE_HOST + 'tmpData/InterruptedDelete', {
                    "userId": userData.userId,
                }, {
                    withCredentials: true
                }).then((res: any) => {}).catch((e: any) => console.log(e));
            }
        }).catch((e: any) => console.log(e));
    }
    useEffect(() => {
        if (!initFlag.current) {
            getSavedData();
            initFlag.current = true;
        }
    }, [])

    /**
     * 中断データ保存
     */
    const saveAnswer = () => {
        if (window.confirm("回答を一時保存しますか？")) {
            const tmpOrder: number[] = [];
            const tmpNums: (string|null)[] = [];
            const tmpQuestionNums: number[] = [];
            answers?.forEach((a, idx) => {
                tmpOrder.push(data[idx]?.testId);
                tmpNums.push(a ? String(a) : null);
                tmpQuestionNums.push(tryingNo);
            })
            axios.post(process.env.REACT_APP_BE_HOST + 'tmpData/InterruptedSave', {
                "userId": userData.userId,
                "questionBook": 7,
                "questionNums": [tryingNo],
                "choiceNums": [tmpNums],
                "questionOrder": tmpOrder,
                "elapsed": `00:00:00`
            }, {
                withCredentials: true
            })
            .then((res: any) => window.alert('回答データを保存しました。'))
            .catch((e) => window.alert('回答データの保存に失敗しました'))
        }
    }

    // 回答送信処理
    const updateUserQuestion = async() => {
        // サーバーにスコアや試験時間などの情報を送信
        await axios.post(process.env.REACT_APP_BE_HOST + 'workbooks/updateUserQuestion', {
            "questionBook": 7,
            "userId": userData.userId,
            "score": 0,
            "time": `00:00:00`,
            "executedAt": new Date(),
            "questionNum": 35,
            "choiceNum1": answers[0] ?? null,
            "choiceNum2": answers[1] ?? null,
            "choiceNum3": answers[2] ?? null,
            "choiceNum4": answers[3] ?? null,
            "choiceNum5": answers[4] ?? null,
            "choiceNum6": answers[5] ?? null,
            "choiceNum7": answers[6] ?? null,
            "choiceNum8": answers[7] ?? null,
            "choiceNum9": answers[8] ?? null,
            "choiceNum10": answers[9] ?? null,
            "choiceNum11": answers[10] ?? null,
            "choiceNum12": answers[11] ?? null,
            "choiceNum13": answers[12] ?? null,
            "choiceNum14": answers[13] ?? null,
            "choiceNum15": answers[14] ?? null,
            "choiceNum16": answers[15] ?? null,
            "choiceNum17": answers[16] ?? null,
            "choiceNum18": answers[17] ?? null,
            "choiceNum19": answers[18] ?? null,
            "choiceNum20": answers[19] ?? null,
            "choiceNum21": answers[20] ?? null,
            "choiceNum22": answers[21] ?? null,
            "choiceNum23": answers[22] ?? null,
            "choiceNum24": answers[23] ?? null,
            "choiceNum25": answers[24] ?? null,
            "choiceNum26": answers[25] ?? null,
            "choiceNum27": answers[26] ?? null,
            "choiceNum28": answers[27] ?? null,
            "choiceNum29": answers[28] ?? null,
            "choiceNum30": answers[29] ?? null,
            "choiceNum31": answers[30] ?? null,
            "choiceNum32": answers[31] ?? null,
            "choiceNum33": answers[32] ?? null,
            "choiceNum34": answers[33] ?? null,
            "choiceNum35": answers[34] ?? null,
        }, {
            withCredentials: true // クッキー情報を含める
        })
        .then(() => {
            // 一時保存データ削除
            axios.post(process.env.REACT_APP_BE_HOST + 'tmpData/InterruptedDelete', {
                "userId": userData.userId,
            }, {
                withCredentials: true
            }).then((res: any) => {}).catch((e: any) => console.log(e));
            // スコア計算
            const reqData = [];
            for (let i = 0; i < 35; i++) {
                reqData.push({questionId: 396 + i, questionNum: answers[i]})
            }
            axios.post(process.env.REACT_APP_BE_HOST + 'workbooks/ScoreResponse', {
                questions: reqData,
                questionBook: 7,
                "userId": userData.userId
            }, {
                withCredentials: true
            }).then((res: any) => {
                setScores([
                    res.data[0]?.photo || 0,
                    res.data[0].image3d || 0,
                    res.data[0].languageImage || 0,
                    res.data[0].languageAbstraction || 0,
                    res.data[0].auditoryLanguage || 0,
                    res.data[0].hearingSound || 0,
                ])
            }).catch((e: any) => console.log(e));
        });
    };

    // 回答終了
    const finishTest = async () => {
        await updateUserQuestion();
        setMode('result');
    }

    return (
        <Container>
            <Box>
                ■ 認知特性テスト
                <Box marginLeft={1} marginTop={2}>
                    <Box>{`問題${tryingNo + 1}`}</Box>
                    <Box marginTop={2} sx={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word'}}>{data[tryingNo]?.question}</Box>
                    <Box mt={2}>
                    {data[tryingNo].choices && data[tryingNo].choices?.map((c, idx) => 
                        <Box
                            key={`choice_${idx}`}
                            border={2}
                            borderColor={'lightGrey'}
                            p={1}
                            my={1}
                            onClick={()=>{
                                selectChoice(tryingNo, c.choiceNum)
                            }}
                            sx={{
                                ":hover": {
                                    background: 'lightGrey'
                                }
                            }}
                        >
                            <Stack direction={'row'}>
                                <Radio
                                    disabled
                                    checked={answers[tryingNo] === c.choiceNum}
                                    key={`r${idx}_${String(c.choiceNum)}_${String(answers[tryingNo])}`}
                                />
                                <Box sx={{display: 'flex', alignItems: 'center'}}>
                                    <div>
                                        {c.choiceText}
                                    </div>
                                </Box>
                            </Stack>
                        </Box>
                    )}
                    </Box>
                    <div style={{display: 'inline-block', float: 'right'}}>
                        <Button
                            sx={{mr: 2}}
                            variant="outlined"
                            onClick={()=> {
                                if(tryingNo === 0){
                                    setMode('desc');
                                } else {
                                    setTryingNo(tryingNo - 1);
                                }
                            }}
                        >
                            戻る
                        </Button>
                        <Button
                            sx={{mr: 2}}
                            variant="outlined"
                            onClick={()=> {saveAnswer()}}
                        >
                            一時保存
                        </Button>
                        <Button
                            variant={answers[tryingNo] == null ? 'outlined' : 'contained'}
                            onClick={()=> {
                                if(tryingNo === 34){
                                    if (answers.includes(null)) {
                                        window.alert('未回答の問題があります。確認してください。');
                                    } else {
                                        finishTest();
                                    }
                                } else {
                                setTryingNo(tryingNo + 1);
                                }
                            }}
                            >
                            {tryingNo === 34 ? '完了' : '次へ'}
                            </Button>
                    </div>
                </Box>
            </Box>
        </Container>
    )
}

export default GTTest;